import { Description, MultipleTextInputs } from "ui";
import { z } from "zod";
import { BlockEditorForm } from "./BlockEditorForm";

const SocialLinksSchema = z.object({
  links: z.array(z.string().url("Must be a valid URL")).min(1, "At least one link is required"),
});

type SocialLinksData = z.infer<typeof SocialLinksSchema>;

interface Props {
  links: string;
  onClose: () => void;
  onUpdate: (links: string) => void;
}

export function SocialLinksEditor({ links, onClose, onUpdate }: Props) {
  const defaultValues: SocialLinksData = {
    links: links
      .split(",")
      .map((link) => link.trim())
      .filter(Boolean)
      .concat([""]), // Add empty field for new input
  };

  const handleSubmit = async (data: SocialLinksData) => {
    const updatedLinks = data.links.filter(Boolean).join(",");
    onUpdate(updatedLinks);
  };

  return (
    <BlockEditorForm schema={SocialLinksSchema} defaultValues={defaultValues} onSubmit={handleSubmit} onClose={onClose}>
      <Description>Add your social media links</Description>
      <MultipleTextInputs name="links" type="url" />
    </BlockEditorForm>
  );
}
